
import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { FaBars, FaTimes, FaChevronDown } from "react-icons/fa";
import Logo from "../../Gallery/VBS_logo_hd.png";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [openServices, setOpenServices] = useState(false);
  const [openMaterials, setOpenMaterials] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();
  const handleMobileNavigate = (path) => {
  navigate(path);
  closeMenu();
};


  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => {
    setMobileMenu(false);
    setOpenServices(false);
    setOpenMaterials(false);
  };

  return (
    <nav className={`nv_wrapper ${scrolled ? "nv_scrolled" : ""}`}>
      <div className="nv_container">

        {/* LOGO */}
 <div className="nv_brand" onClick={() => navigate("/")}>
  <img src={Logo} className="nv_logo" alt="VB Shah Logo" />

  <div className="nv_brand_text">

    {/* Company Name + Tagline */}
    <h1 className="nv_title">VB SHAH INC</h1>
    <p className="nv_tagline">Engineering Spares Exports and Suppliers</p>

    {/* Divider Line */}
    <div className="nv_divider"></div>

    {/* Contact & Email */}
    <div className="nv_contact_block">
      <p className="nv_contact">+91 93270 07508 | 7948449933</p>
      <p className="nv_email">sales@vbshah.com</p>
    </div>

  </div>
</div>


        {/* DESKTOP MENU */}
        <ul className="nv_links">

          <li className="nv_item">
            <button className="nav_btn" onClick={() => navigate("/")}>HOME</button>
          </li>

          {/* SERVICES MEGA MENU */}
          <li
            className="nv_item nv_dropdown"
            onMouseEnter={() => setOpenServices(true)}
            onMouseLeave={() => setOpenServices(false)}
          >
            <span>
              SERVICES <FaChevronDown className={`arrow ${openServices ? "rotate" : ""}`} />
            </span>

            {openServices && (
              <div className="mega_menu">

                <div className="mega_col">
                  <h4>Design & Software</h4>
                  <button onClick={()=> navigate("/Metal3D")} >Metal 3D Printing</button> 
                  <button onClick={()=> navigate("/CADModelling")}>CAD Modelling Software</button>
                  <button onClick={()=> navigate("/Machine")}>Machining</button>
                </div>

                <div className="mega_col">
                  <h4>Treatment & Engineering</h4>
                  <button onClick={()=> navigate("/AdditiveManufacturing")}>Additive Manufacturing</button>
                  <button onClick={()=> navigate("/CNC")}>CNC Machining</button>
                  <button onClick={()=> navigate("/VacumF")}>Vacuum Formed Enclosures</button>
                  <button onClick={()=> navigate("/PT")}> Packaging Trays </button>
                </div>

                <div className="mega_col">
                  <h4>Molding & Casting</h4>
                  <button onClick={()=> navigate("/VC")}>Vacuum Casting</button>
                  <button onClick={()=> navigate("/IM")} >Injection Moulding</button>
                  <button onClick={()=> navigate("/MM")} >Mold Manufacturing</button>
                  <button onClick={()=> navigate("/RE")}>Reverse Engineering</button>
                </div>

              </div>
            )}
          </li>

          {/* MATERIALS MEGA MENU */}
          <li
            className="nv_item nv_dropdown"
            onMouseEnter={() => setOpenMaterials(true)}
            onMouseLeave={() => setOpenMaterials(false)}
          >
            <span>
              MATERIALS <FaChevronDown className={`arrow ${openMaterials ? "rotate" : ""}`} />
            </span>

            {openMaterials && (
              <div className="mega_menu">

          

                <div className="mega_col">
                  <h4>SS310L</h4>
                  <button onClick={()=> navigate("/Sspartone")}>SS316L parts</button>
                  <button onClick={()=> navigate("/Ssparttwo")}>SS316L Parts</button>
                </div>

                <div className="mega_col">
                  <h4>MSL Maraging Steel</h4>
                  <button onClick={()=> navigate("/Msone")}>MsI Injection Mould</button>
                </div>

              </div>
            )}
          </li>

          <li className="nv_item">
            <button className="nav_btn" onClick={() => navigate("/about")}>ABOUT US</button>
          </li>

          <li className="nv_item">
            <button className="nav_btn" onClick={() => navigate("/contact")}>CONTACT</button>
          </li>

            <li className="nv_item">
  <button onClick={() => navigate("/rfq")} id="quote_btn" >
    Get A Quote
  </button>
</li>

        </ul>

        {/* MOBILE MENU ICON */}
        <div className="nv_mobile_icon" onClick={() => setMobileMenu(!mobileMenu)}>
          {mobileMenu ? <FaTimes /> : <FaBars />}
        </div>

        {/* MOBILE MENU */}
        <div className={`nv_mobile_menu ${mobileMenu ? "open" : ""}`}>
          <div className="mobile_header">
            <div className="nv_brand_mobile">
              <img src={Logo} className="nv_logo" alt="VB Shah Logo" />
              <div className="nv_brand_text">
                <h1 className="nv_title">VB SHAH INC</h1>
                <p className="nv_tagline">Engineering Spares Exports and Suppliers</p>
              </div>
            </div>
            <FaTimes className="close_icon" onClick={closeMenu} />
          </div>

          <button className="nav_btn" onClick={() => { navigate("/"); closeMenu(); }}>HOME</button>

          {/* MOBILE SERVICES */}
<p
  className="mobile_drop"
  onClick={() => {
    setOpenServices(!openServices);
    setOpenMaterials(false);
  }}
>
  SERVICES{" "}
  <FaChevronDown className={`arrow ${openServices ? "rotate" : ""}`} />
</p>

{openServices && (
  <div className="mobile_dropdown_panel">

    <button onClick={() => handleMobileNavigate("/Metal3D")}>
      Metal 3D Printing
    </button>

    <button onClick={() => handleMobileNavigate("/CADModelling")}>
      CAD Modelling Software
    </button>

    <button onClick={() => handleMobileNavigate("/Machine")}>
      Machining
    </button>

    <button onClick={() => handleMobileNavigate("/AdditiveManufacturing")}>
      Additive Manufacturing
    </button>

    <button onClick={() => handleMobileNavigate("/CNC")}>
      CNC Machining
    </button>

    <button onClick={() => handleMobileNavigate("/VacumF")}>
      Vacuum Formed Enclosures
    </button>

    <button onClick={() => handleMobileNavigate("/PT")}>
      Packaging Trays
    </button>

    <button onClick={() => handleMobileNavigate("/VC")}>
      Vacuum Casting
    </button>

    <button onClick={() => handleMobileNavigate("/IM")}>
      Injection Moulding
    </button>

    <button onClick={() => handleMobileNavigate("/MM")}>
      Mold Manufacturing
    </button>

    <button onClick={() => handleMobileNavigate("/RE")}>
      Reverse Engineering
    </button>

  </div>
)}


          {/* MOBILE MATERIALS */}
          <p className="mobile_drop" onClick={() => setOpenMaterials(!openMaterials)}>
            MATERIALS <FaChevronDown className={`arrow ${openMaterials ? "rotate" : ""}`} />
          </p>

          {openMaterials && (
            <div className="mobile_dropdown_panel">
               <h4>SS310L</h4>
                  <button onClick={()=> handleMobileNavigate("/Sspartone")}>SS316L parts</button>
                  <button onClick={()=> handleMobileNavigate("/Ssparttwo")}>SS316L Parts</button>
              
               <h4>MSL Maraging Steel</h4>
                  <button onClick={()=> handleMobileNavigate("/Msone")}>MsI Injection Mould</button>

            </div>
          )}

          <button className="nav_btn" onClick={() => { handleMobileNavigate("/about"); closeMenu(); }}>ABOUT US</button>

          <button className="nav_btn" onClick={() => { handleMobileNavigate("/contact"); closeMenu(); }}>CONTACT</button>
          {/* <button className="nav_btn" onClick={() => { handleMobileNavigate("/contact"); closeMenu(); }}>CONTACT</button> */}
           <button className="nav_btn" onClick={() => { handleMobileNavigate("/rfq"); closeMenu(); }} id="quote_btn" > Get A Quote</button>

        </div>

      </div>
    </nav>
  );
}

export default Navbar;
